import * as flatbuffers from "flatbuffers"

/**
 * The only difference between our own datagram buffer builder and the stock flatbuffers
 * builder is that we cache the different kinds of ids along the way during building so that
 * we can re-use them (flatbuffers only cares about offsets, so multiple objects can
 * re-use the same inner objects by giving the same offset in their vtable).
 */
export class DatagramBufferBuilder extends flatbuffers.Builder {
  uuids: Map<string, flatbuffers.Offset> = new Map()
  values: Map<string, flatbuffers.Offset> = new Map()
  entityIds: Map<string, flatbuffers.Offset> = new Map()
  fileIds: Map<string, flatbuffers.Offset> = new Map()
  userIds: Map<string, flatbuffers.Offset> = new Map()
  sharedDriveIds: Map<string, flatbuffers.Offset> = new Map()
  searchIds: Map<string, flatbuffers.Offset> = new Map()
  conversationIds: Map<string, flatbuffers.Offset> = new Map()
  entityPropertyIds: Map<string, flatbuffers.Offset> = new Map()
  filePropertyIds: Map<string, flatbuffers.Offset> = new Map()
  userPropertyIds: Map<string, flatbuffers.Offset> = new Map()
  searchPropertyIds: Map<string, flatbuffers.Offset> = new Map()
  conversationPropertyIds: Map<string, flatbuffers.Offset> = new Map()
}
